"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MathFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var MathFactory = /** @class */ (function (_super) {
    __extends(MathFactory, _super);
    function MathFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MathFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    MathFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    MathFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MathFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MathFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return MathFactory;
}(contracts_1.ContractFactory));
exports.MathFactory = MathFactory;
var _abi = [
    {
        inputs: [],
        name: "BASE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "0x608e610038600b82828239805160001a607314602b57634e487b7160e01b600052600060045260246000fd5b30600052607381538281f3fe730000000000000000000000000000000000000000301460806040526004361060335760003560e01c8063ec342ad0146038575b600080fd5b6046670de0b6b3a764000081565b60405190815260200160405180910390f3fea26469706673582212205d0f614319015acd609a3847f1a7cdcc9ae618c26a9f5abee3c827563c89362e64736f6c63430008040033";
